import { render, staticRenderFns } from "./TableModalDoctorXPayment.vue?vue&type=template&id=0921ae71"
import script from "./TableModalDoctorXPayment.vue?vue&type=script&lang=js"
export * from "./TableModalDoctorXPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports